module.exports = __webpack_public_path__ + "img/center_year.47c3c42a.png";